import React from 'react';
import { Timer } from 'lucide-react';
import { cn } from '../../utils/cn';
import { formatTimerDisplay } from '../../utils/timeFormatting';

interface GameStopwatchProps {
  isCountingDown: boolean;
  countdownSeconds: number;
  isRunning: boolean;
  liveElapsedMs: number;
  className?: string;
}

const timerAccent = 'text-emerald-700 dark:text-emerald-300';

export const GameStopwatch: React.FC<GameStopwatchProps> = ({
  isCountingDown,
  countdownSeconds,
  isRunning,
  liveElapsedMs,
  className = '',
}) => {
  const textSize = 'text-xs';
  const iconSize = 'w-3 h-3';

  // Countdown phase: "GO!" state
  if (isCountingDown && countdownSeconds === 0) {
    return (
      <div className={cn('inline-flex items-center gap-1 text-foreground font-medium tracking-tight', textSize, className)}>
        <Timer className={cn(iconSize, timerAccent)} strokeWidth={2.4} aria-hidden="true" />

        <span className="font-bold text-green-500 animate-pulse">GO!</span>
      </div>
    );
  }

  // Countdown phase: counting down (5, 4, 3, 2, 1)
  if (isCountingDown && countdownSeconds > 0) {
    return (
      <div className={cn('inline-flex items-center gap-1 text-foreground font-medium tracking-tight', textSize, className)}>
        <Timer className={cn(iconSize, timerAccent)} strokeWidth={2.4} aria-hidden="true" />

        <span className="font-bold tabular-nums">{countdownSeconds}...</span>
      </div>
    );
  }

  // Stopwatch running: show elapsed time
  if (isRunning) {
    return (
      <div className={cn('inline-flex items-center gap-1 text-foreground font-medium tracking-tight', textSize, className)}>
        <Timer className={cn(iconSize, timerAccent)} strokeWidth={2.4} aria-hidden="true" />

        <span className="font-bold tabular-nums">
          {formatTimerDisplay(liveElapsedMs)}
        </span>
      </div>
    );
  }

  // Not started yet
  return null;
};
